import { render, staticRenderFns } from "./Maruteru.vue?vue&type=template&id=09315c47&scoped=true"
import script from "./Maruteru.vue?vue&type=script&lang=js"
export * from "./Maruteru.vue?vue&type=script&lang=js"
import style0 from "./Maruteru.vue?vue&type=style&index=0&id=09315c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09315c47",
  null
  
)

export default component.exports